module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/resetcategory"
    }
  }, [_vm._v("\n                            Move to new Category\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-box-fl"
  }, [_c('h4', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/settings/addtocategories"
    }
  }, [_vm._v("\n                            Add to new Categories\n                            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59346a4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Manage/ItemSettings/AddToCategories.vue
// module id = 585
// module chunks = 0